interface Attribute {
  attributeName: string;
  windowAvg: string;
  RateDiff: string;
  attributeValue: string;
  operation: string;
  RawValue: string;
}

interface DataItem {
  attributes: Attribute[];
}

export interface ApiResponse {
  status: boolean;
  response: {
    data: DataItem[];
  };
}

export interface WidgetData {
  refreshRate: number 
  title: string,
  entityType: string
}
